import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import provider_profile from "../../assets/images/provider_profile.jpg";
import saad from "../../assets/images/saad.png";
import { useParams } from "react-router-dom";
import { notificationService } from "../../services/notificationService";
import { urlConfig } from "../../config/baseUrl";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";

const NotificationDetails = () => {
  const { t } = useContext(LocaleContext);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails();
  }, [id]);

  const getDetails = async () => {
    try {
      const res = await notificationService.getDetail(id);
      setData(res.value);
      console.log(res.value);
    } catch (error) {
      console.error("Error fetching notification details:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;
  return (
    <section className="section-notification-details">
      <div className="default-heading">{t("notifications")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("notificationDetails")}
          <BackButton />
        </div>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="trip-provider-information">
                <div className="trip-provider-profile-layer">
                  <div className="trip-provider-profile">
                    <img
                      src={
                        data?.imagePath
                          ? `${urlConfig.imageBaseUrl}/${data.imagePath}`
                          : provider_profile
                      }
                      alt="Provider Profile"
                    />
                  </div>
                </div>
                {/* <b>
                  <i className="fas fa-images"></i> {t("edit")}
                </b> */}
              </div>
            </div>
            <div className="col-12 col-md-8 h-100">
              <div className="row h-100">
                <div className="col-12 col-md-12">
                  <div className="my-dark-card-items">
                    <div className="my-dark-card-item">
                      <strong>{t("userName")}</strong>
                      <span>{data?.userName}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("noOfNotificationsSent")}</strong>
                      <span>{data?.noOfNotificationsSent || 0}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("registrationDate")}</strong>
                      <span>{data?.registrationDate?.toDate()}</span>
                    </div>
                  </div>
                  <div className="my-dark-card-items border-0">
                    <div className="my-dark-card-item">
                      <strong>{t("totalRevenue")}</strong>
                      <span>{data?.totalRevenue || 0} {t("riyal")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="provider-latest-updates mt-3">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="my-card my-card-scroll provider-detail-list-items">
              <div className="my-card-header">{t("recentNotifications")}</div>
              {data?.recentNotifications?.length > 0 ? (
                data.recentNotifications.map((notif) => (
                  <div key={notif.id} className="provider-latest-updates-item">
                    <div className="mt-2">
                      <p className="provider-latest-updates-item-title">
                        <b>{notif.message}</b>
                      </p>
                      <p className="provider-latest-updates-item-date text-dim">
                        {notif.date?.toDate()}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <div className="provider-latest-updates-image-box">
                    <img src={saad} alt="Saad" />
                  </div>
                  <p className="text-center">{t("noRecentNotifications")}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default NotificationDetails;
